<template>
  <x-dialog
    :dialogState="dialogState"
    :dialogTitle="dialogTitle"
    :dialogText="dialogText"
    @toggleModal="toggleConfirmDialog"
    :confirmDialog="true"
    :actions="{
      show: true,
      secondaryButtonFunction: toggleConfirmDialog,
      primaryButtonFunction: () => makeAsDefaultPayment(cardId),
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Confirm',
      primaryButtonDisabled: isPrimaryButtonDisabled
    }"
    data-test-id="mark-payment-card-as-default-dialog"
  ></x-dialog>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  name: 'default-payment-profile-confirm-dialog',
  props: {
    toggleConfirmDialog: {
      type: Function
    },
    dialogState: {
      type: Boolean
    },
    cardId: {
      type: String
    }
  },
  data() {
    return {
      dialogTitle: 'Please Confirm',
      dialogText:
        'Are you sure you want to make this payment method as default',
      isPrimaryButtonDisabled: false
    };
  },
  methods: {
    async makeAsDefaultPayment(profileId) {
      this.isPrimaryButtonDisabled = true;
      try {
        const defaultPaymentProfileData = await this.$services.billing.defaultPaymentProfile(
          profileId
        );
        if (defaultPaymentProfileData) {
          this.setDefaultPaymentProfile(profileId);
          this.snackbar('success', this.$message.UPDATE_SUCCESS);
        }
        this.toggleConfirmDialog();
      } catch (err) {
        this.snackbar('error', err);
      } finally {
        this.isPrimaryButtonDisabled = false;
      }
    },
    ...mapMutations(['setDefaultPaymentProfile'])
  }
};
</script>
